import StatusColor, { StatusColorEnum } from 'components/status-badge';
import useDashboardContext from 'contexts/dashboard.context';
import { StoreType } from 'models/store.model';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { STORAGE_KEYS } from 'utils/constants';
import { formatDate } from 'utils/functions';
import { getTeamRoles } from 'utils/role-config';
import { ENUM_ALL_ROLES } from 'utils/roles';
import { getDefaultAuthorizedRoute } from 'utils/route-authorization';
import { readStoredPermissions, readStoredRole } from 'utils/authorization';

const StoreCard = ({ store }: { store: StoreType }) => {
  const { name, created_at, updated_at, active, id } = store;
  const navigate = useNavigate();
  const { setActiveStore, activeStore, setShowStores } = useDashboardContext();
  const getDisplayName = () => {
    const getFirstAndLastLetters = (text: string) => {
      const words = text.split(' ');
      const firstLetter = words[0].split('')[0] || '';
      const lastLetter = words[words.length - 1].split('')[0] || '';
      return `${firstLetter}${lastLetter}`.toUpperCase();
    };
    return getFirstAndLastLetters(name);
  };
  const goToStoreDetails = (e: React.MouseEvent<HTMLParagraphElement>) => {
    e.stopPropagation();
    setActiveStore(store);
    navigate(`/general-store/${id}`);
  };
  const changeActiveStore = () => {
    const roleConfig = getTeamRoles();
    const role = (readStoredRole()?.name ?? '') as ENUM_ALL_ROLES;
    const permissions = readStoredPermissions();
    const fallbackRoute = getDefaultAuthorizedRoute(permissions);
    const roleBaseRoute = roleConfig?.[role]?.baseRoute ?? '';
    const nextRoute = roleBaseRoute.startsWith('/') ? roleBaseRoute : fallbackRoute;

    sessionStorage.setItem(STORAGE_KEYS.ACTIVE_STORE, JSON.stringify(store));
    setActiveStore(store);
    setShowStores(false);
    navigate(nextRoute);
  };
  return (
    <div
      className={`border ${
        activeStore?.id === store.id ? 'border-red-4' : 'border-gray-1/80'
      }  rounded-md text-sm cursor-pointer `}
      onClick={changeActiveStore}>
      <div className='flex justify-between p-3.5'>
        <div className='flex items-center gap-3'>
          {store.logo !== '' ? (
            <img className='w-12 h-12 rounded ' src={store.logo} />
          ) : (
            <div className='bg-red-5 rounded text-white text-2xl w-12 h-12 inline-flex items-center justify-center'>
              {getDisplayName()}
            </div>
          )}
          <div>
            <h4 className='font-medium text-base'>{name}</h4>
            <p className='text-gray-4 text-sm'>Cokitchen | Lekki</p>
          </div>
        </div>
        <div className='text-center'>
          <p onClick={goToStoreDetails} className='text-red-5 underline text-xs pb-1'>
            Edit
          </p>
          <StatusColor status={active ? StatusColorEnum.active : StatusColorEnum.inactive} />
        </div>
      </div>
      <hr className='border-gray-1/80 my-3' />
      <div className='flex items-center justify-between p-3.5'>
        <div>
          <p className='text-gray-4 '>Date Created</p>
          <p className='font-medium'> {formatDate(created_at)}</p>
        </div>
        <div>
          <p className='text-gray-4 '>Date Updated</p>
          <p className='font-medium'>{formatDate(updated_at)}</p>
        </div>
      </div>
    </div>
  );
};

export default StoreCard;
